import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { OptionInterface } from '../../../models/option.interface';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { Store } from '@ngrx/store';
import { SaveMission } from '../../../store/actions/mission.actions';

@Component({
  selector: 'app-deactivate-options',
  templateUrl: './deactivate-options.component.html',
  styleUrls: ['./deactivate-options.component.css'],
  standalone: false
})
export class DeactivateOptionsComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  filteredOptions: Array<OptionInterface>;
  data: {
    atRenewal: Array<number>;
    immediate: Array<number>
  }|null;

  constructor(
      private store: Store<any>,
  ) {}

  ngOnInit(): void {
    this.data = { atRenewal: [], immediate: [] };
    this.filteredOptions = [];
    for (const option of this.line.options) {
      if (option.skuOption && option.skuOption.includes('postpaid_option')) {
        this.filteredOptions.push(option);
      }
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  update(type: string, optionId: number) {
    const immediateIndex = this.data.immediate.findIndex(optId => optId === optionId);
    const renewalIndex = this.data.atRenewal.findIndex(optId => optId === optionId);
    if (type == 'no') {
      if (immediateIndex !== -1 ) {
        this.data.immediate.splice(immediateIndex, 1)
      }
      if (renewalIndex !== -1 ) {
        this.data.atRenewal.splice(renewalIndex, 1)
      }
    } else if (type == 'immediate') {
      this.data.immediate.push(optionId);
      if (renewalIndex !== -1 ) {
        this.data.atRenewal.splice(renewalIndex, 1)
      }
    } else {
      this.data.atRenewal.push(optionId);
      if (immediateIndex !== -1 ) {
        this.data.immediate.splice(immediateIndex, 1)
      }
    }
  }
  save() {
    this.store.dispatch(
        new SaveMission(
            {
              phoneNumber: this.line.phoneNumber,
              immediate: this.data.immediate,
              atRenewal: this.data.atRenewal,
            },
            this.procedureCode
        )
    );
  }
}
